import {useState} from 'react';
import {
    Profile as ProfileComponent, 
} from "src/Components/Molecules/Card";

export default function Profile({objective, sectors, title}) {
    
    if (!objective) {
        return null;
    }

    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm" id="newsContent">
            <h2 className="card-title" data-testid="companyProfileHeader">{title}</h2>
            <ProfileComponent  objective={objective} sectors={sectors} />
        </div>
    </div>

}